<template>
  <div class="school-info-container">
    <div class="page-header">
      <div class="breadcrumb">ຂໍ້ມູນໂຮງຮຽນ / <span>ແກ້ໄຂຂໍ້ມູນໂຮງຮຽນ</span></div>
      <div class="header-content">
        <h1>ຈັດການຂໍ້ມູນໂຮງຮຽນ</h1>
        <p>ກວດສອບ ແລະ ປັບປຸງຂໍ້ມູນພື້ນຖານຂອງໂຮງຮຽນໃຫ້ຄົບຖ້ວນຕາມເງື່ອນໄຂ</p>
      </div>
    </div>

    <div v-if="loading" class="loading-state-full">
      <i class="fas fa-spinner fa-spin fa-3x"></i>
      <p>ກຳລັງໂຫຼດຂໍ້ມູນ...</p>
    </div>

    <form v-else @submit.prevent="handleSubmit">
      <!-- Group 1: ຂໍ້ມູນທີ່ຕັ້ງ (Read-only ຈາກ User-info) -->
      <div class="panel mb-4 shadow-sm">
        <div class="panel-head">
          <h3><i class="fas fa-map-marker-alt"></i> ຂໍ້ມູນສັງກັດ ແລະ ທີ່ຕັ້ງ</h3>
        </div>
        <div class="panel-body">
          <div class="field-row-3">
            <div class="form-group">
              <label>ລະຫັດໂຮງຮຽນ</label>
              <input type="text" v-model="form.school_id" readonly class="readonly-input">
            </div>
            <div class="form-group">
              <label>ແຂວງ</label>
              <input type="text" v-model="form.prov_name" readonly class="readonly-input">
            </div>
            <div class="form-group">
              <label>ເມືອງ</label>
              <input type="text" v-model="form.district_name_lao" readonly class="readonly-input">
            </div>
          </div>
          <div class="field-row">
            <div class="form-group">
              <label>ຊື່ຕາແສງ <span class="req">*</span></label>
              <input type="text" v-model="form.commune_name" placeholder="ປ້ອນຊື່ຕາແສງ">
            </div>
            <div class="form-group">
              <label>ຊື່ບ້ານທີ່ໂຮງຮຽນຕັ້ງຢູ່ <span class="req">*</span></label>
              <input type="text" v-model="form.school_village" placeholder="ປ້ອນຊື່ບ້ານ">
            </div>
          </div>
        </div>
      </div>

      <!-- Group 2: ລາຍລະອຽດໂຮງຮຽນ -->
      <div class="panel mb-4 shadow-sm">
        <div class="panel-head">
          <h3><i class="fas fa-info-circle"></i> ລາຍລະອຽດ ແລະ ເງື່ອນໄຂ</h3>
        </div>
        <div class="panel-body">
          <div class="field-row">
            <div class="form-group">
              <label>ຊື່ໂຮງຮຽນ (ພາສາລາວ) <span class="req">*</span></label>
              <input type="text" v-model="form.school_name_lao" placeholder="ປ້ອນຊື່ໂຮງຮຽນ" required>
            </div>
            <div class="form-group">
              <label>ຂັ້ນການສຶກສາ <span class="req">*</span></label>
              <div class="input-with-action pointer" @click="openLevelModal">
                <input type="text" :value="form.school_level_lao" readonly placeholder="ເລືອກຂັ້ນການສຶກສາ">
                <button type="button" class="btn-icon"><i class="fas fa-search"></i></button>
              </div>
            </div>
          </div>

          <div class="field-row">
            <div class="form-group">
              <label>ປະເພດໂຮງຮຽນ <span class="req">*</span></label>
              <div class="input-with-action pointer" @click="openTypeModal">
                <input type="text" :value="form.schooltype" readonly placeholder="ເລືອກປະເພດໂຮງຮຽນ">
                <button type="button" class="btn-icon"><i class="fas fa-search"></i></button>
              </div>
            </div>
            <div class="form-group">
              <label>ໂຄງການອາຫານທ່ຽງ</label>
              <div class="status-selector">
                <label class="status-btn p" :class="{active: form.school_lunch == 1}">
                  <input type="radio" v-model.number="form.school_lunch" :value="1"> ມີ
                </label>
                <label class="status-btn a" :class="{active: form.school_lunch == 0}">
                  <input type="radio" v-model.number="form.school_lunch" :value="0"> ບໍ່ມີ
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-actions-wrapper">
        <button type="submit" class="btn-save" :disabled="submitting">
          <i class="fas" :class="submitting ? 'fa-spinner fa-spin' : 'fa-save'"></i>
          {{ submitting ? 'ກຳລັງບັນທຶກ...' : 'ບັນທຶກຂໍ້ມູນໂຮງຮຽນ' }}
        </button>
      </div>
    </form>

    <!-- Modal ເລືອກຂັ້ນການສຶກສາ -->
    <transition name="modal">
      <div v-if="levelModal.show" class="modal-overlay" @mousedown.self="closeLevelModal">
        <div class="custom-modal-card" role="dialog">
          <div class="custom-modal-header">
            <h3>ເລືອກຂັ້ນການສຶກສາ</h3>
            <button @click="closeLevelModal" class="close-btn">&times;</button>
          </div>
          <div class="custom-modal-body">
            <div v-for="item in levelModal.items" :key="item.id" class="list-item" @click="selectLevel(item)">
              <span class="item-name">{{ item.name }}</span>
              <i class="fas fa-chevron-right"></i>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal ເລືອກປະເພດໂຮງຮຽນ -->
    <transition name="modal">
      <div v-if="typeModal.show" class="modal-overlay" @mousedown.self="closeTypeModal">
        <div class="custom-modal-card" role="dialog">
          <div class="custom-modal-header">
            <h3>ເລືອກປະເພດໂຮງຮຽນ</h3>
            <button @click="closeTypeModal" class="close-btn">&times;</button>
          </div>
          <div class="custom-modal-body">
            <div v-for="item in typeModal.items" :key="item.id" class="list-item" @click="selectType(item)">
              <span class="item-name">{{ item.name }}</span>
              <i class="fas fa-chevron-right"></i>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal ແຈ້ງຜົນຮັບ (Result Modal) -->
    <transition name="modal">
      <div v-if="resultModal.show" class="modal-overlay" @mousedown.self="resultModal.show = false">
        <div class="custom-modal-card result-modal">
          <div class="modal-icon" :class="resultModal.type">
            <i class="fas" :class="resultModal.type === 'success' ? 'fa-check-circle' : 'fa-times-circle'"></i>
          </div>
          <div class="modal-content-area">
            <h2>{{ resultModal.title }}</h2>
            <p>{{ resultModal.message }}</p>
          </div>
          <div class="modal-footer-actions">
            <button class="btn-modal-primary" :class="resultModal.type" @click="resultModal.show = false">ເຂົ້າໃຈແລ້ວ</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/utils/api';

export default {
  name: 'SchoolInfoPage',
  data() {
    return {
      loading: false,
      submitting: false,
      isNew: true,
      user: {},
      form: {
        prov_id: '',
        prov_name: '',
        district_id: '',
        district_name_lao: '',
        school_id: '',
        school_name_lao: '',
        commune_name: '',
        school_village: '',
        level_id: null,
        school_level_lao: '',
        schooltype_code: null,
        schooltype: '',
        school_lunch: 0
      },
      levelModal: { show: false, items: [
        { id: 1, name: 'ອະນຸບານ' },
        { id: 2, name: 'ປະຖົມ' },
        { id: 3, name: 'ມັດທະຍົມຕົ້ນ' },
        { id: 4, name: 'ມັດທະຍົມປາຍ' }
      ]},
      typeModal: { show: false, items: [
        { id: 1, name: 'ໂຮງຮຽນລັດ' },
        { id: 2, name: 'ໂຮງຮຽນເອກະຊົນ' }
      ]},
      resultModal: { show: false, type: 'success', title: '', message: '' }
    };
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem('user-info') || '{}');
    await this.fetchSchoolData();
  },
  methods: {
    async fetchSchoolData() {
      if (!this.user.school_id) return;
      this.loading = true;
      try {
        const res = await api.get(`/getAll/schools/school_id/${this.user.school_id}`);
        if (res.data.code === 1 && res.data.rows.length > 0) {
          this.form = { ...this.form, ...res.data.rows[0] };
          this.isNew = false;
        } else {
          // ຖ້າບໍ່ທັນມີຂໍ້ມູນ ໃຫ້ດຶງຂໍ້ມູນພື້ນຖານຈາກ user-info ມາເປັນຄ່າເລີ່ມຕົ້ນ
          this.form.school_id = this.user.school_id;
          this.form.prov_id = this.user.prov_id;
          this.form.prov_name = this.user.prov_name;
          this.form.district_id = this.user.district_id;
          this.form.district_name_lao = this.user.district_name_lao;
          this.isNew = true;
        }
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    openLevelModal() { this.levelModal.show = true; this.disableScroll(); },
    closeLevelModal() { this.levelModal.show = false; this.enableScroll(); },
    selectLevel(item) {
      this.form.level_id = item.id;
      this.form.school_level_lao = item.name;
      this.closeLevelModal();
    },
    openTypeModal() { this.typeModal.show = true; this.disableScroll(); },
    closeTypeModal() { this.typeModal.show = false; this.enableScroll(); },
    selectType(item) {
      this.form.schooltype_code = item.id;
      this.form.schooltype = item.name;
      this.closeTypeModal();
    },
    showResult(type, title, message) {
      this.resultModal = { show: true, type, title, message };
    },
    disableScroll() { document.body.style.overflow = 'hidden'; },
    enableScroll() { document.body.style.overflow = ''; },
    async handleSubmit() {
      this.submitting = true;
      try {
        let res;
        if (this.isNew) {
          res = await api.post('/insertOne', { table: 'school_profile', items: this.form });
        } else {
          res = await api.put(`/update/schools/${this.form._id}`, { items: this.form });
        }

        if (res.data.code === 1) {
          this.showResult('success', 'ສຳເລັດແລ້ວ', 'ບັນທຶກຂໍ້ມູນໂຮງຮຽນຮຽບຮ້ອຍແລ້ວ');
          await this.fetchSchoolData();
        } else {
          this.showResult('error', 'ເກີດຂໍ້ຜິດພາດ', res.data.desc || 'ບໍ່ສາມາດບັນທຶກຂໍ້ມູນໄດ້');
        }
      } catch (e) {
        this.showResult('error', 'ເກີດຂໍ້ຜິດພາດ', 'ບໍ່ສາມາດເຊື່ອມຕໍ່ກັບເຊີເວີໄດ້');
      } finally { this.submitting = false; }
    }
  }
};
</script>

<style scoped>
.school-info-container { animation: fadeIn 0.4s ease; max-width: 1000px; margin: 0 auto; }
.field-row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
.field-row-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
.readonly-input { background: #f8fafc !important; cursor: not-allowed; color: #64748b; }
.req { color: var(--danger); }

.status-selector { display: flex; background: #f1f5f9; padding: 4px; border-radius: 10px; gap: 4px; }
.status-btn { flex: 1; padding: 10px; border-radius: 8px; cursor: pointer; font-weight: 600; text-align: center; transition: 0.2s; font-size: 13px; }
.status-btn input { display: none; }
.status-btn.p.active { background: #10b981; color: white; }
.status-btn.a.active { background: #64748b; color: white; }

.input-with-action { position: relative; display: flex; align-items: center; }
.input-with-action input { padding-right: 40px !important; cursor: pointer; }
.btn-icon { position: absolute; right: 12px; background: none; border: none; color: var(--lao); cursor: pointer; }

.loading-state-full { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 100px 0; color: var(--text3); }

/* Modal Styles (Inherited pattern) */
.modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.4); backdrop-filter: blur(4px); display: flex; justify-content: center; align-items: center; z-index: 9999; }
.custom-modal-card { background: white; width: 100%; max-width: 450px; border-radius: 16px; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1); overflow: hidden; animation: modalPop 0.3s ease; }
.custom-modal-header { padding: 20px; border-bottom: 1px solid #f1f5f9; display: flex; justify-content: space-between; align-items: center; }
.list-item { padding: 15px 20px; display: flex; justify-content: space-between; align-items: center; cursor: pointer; border-bottom: 1px solid #f8fafc; }
.list-item:hover { background: #f0f7ff; }

.result-modal { text-align: center; padding: 40px 30px; }
.modal-icon { font-size: 60px; margin-bottom: 20px; }
.modal-icon.success { color: #10b981; }
.modal-icon.error { color: #ef4444; }

.btn-save { background: var(--lao); color: white; padding: 12px 40px; border-radius: 10px; font-weight: 700; border: none; cursor: pointer; width: 100%; transition: 0.3s; margin-top: 20px; }
.btn-save:hover:not(:disabled) { background: var(--lao-mid); transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,63,138,0.2); }

@keyframes modalPop { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>